import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectFieldPlaceholder: {
		id: 'polaris-component-project-select.select-field-placeholder',
		defaultMessage: 'Select projects',
		description: 'Placeholder for projects select field',
	},
});
